import React, { useContext, Fragment, createContext, useReducer } from 'react'
import { AuthContext } from '../../../App/App'
import FilterHeader from './FilterHeader';
import FilterBody from './FilterBody';
import ChatHeader from './ChatHeader';
import ChatBody from './ChatBody';
import ChatFooter from './ChatFooter';

export const CloseChatContext = createContext();

function ComplateMessages() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext)

    const initialReducer = {
        action: 'helpdesk',
        filter: 'all',
        subFilter: null,
        chats: [],
        chat: [],
        trigger: { message: null },
        active: null,
        userCategory: null
    }
    const reducer = (state, action) => {
        switch (action.type) {
            case "ACTION":
                return {
                    ...state,
                    action: action.action,
                    filter: 'all',
                    active: null,
                    chats: []
                }
            case 'FILTER':
                return {
                    ...state,
                    filter: action.filter,
                    subFilter: action.subFilter,
                    endpoint: action.endpoint
                }
            case 'TRIGGER':
                return {
                    ...state,
                    trigger: action.trigger
                }
            case 'USER_CATEGORY':
                return {
                    ...state,
                    userCategory: action.userCategory
                }
            case 'ACTIVE':
                return {
                    ...state,
                    active: action.active
                }
            case 'CHATS':
                return {
                    ...state,
                    chats: action.chats
                }
            case 'CHAT':
                return {
                    ...state,
                    chat: action.chat
                }
            default:
                return state
        }
    }
    const [state, dispatch] = useReducer(reducer, initialReducer)


    const handleActionClick = (action) => {
        dispatch({
            type: 'ACTION',
            action: action,
        })
    }

    return (
        <div className="section-body">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0 mt-2 ml-0 mr-0">

                            <div className="row justify-content-start ml-3 mb-3">
                                <div className="col-auto" >
                                    <div className={`btn btn-icon icon-left ${state.action == 'helpdesk' ? 'btn-primary' : 'btn-success'}`} style={{ borderRadius: '20px', textTransform: 'capitalize', fontSize: '1.5em', fontWeight: 'bolder' }}><i className={(state.action == 'helpdesk' ? `fas fa-hands-helping` : `fab fa-whatsapp`)} style={{ fontSize: '1em' }}></i>{state.action}</div>
                                </div>
                                <div className="col-auto" >
                                    <div className={`btn btn-icon icon-left btn-secondary`} onClick={handleActionClick.bind(this, (state.action == 'whatsapp' ? 'helpdesk' : 'whatsapp'))} style={{ borderRadius: '20px', textTransform: 'capitalize', fontSize: '1.5em', fontWeight: 'normal' }}><i className={(state.action == 'helpdesk' ? `fab fa-whatsapp` : `fas fa-hands-helping`)} style={{ fontSize: '1em' }}></i></div>
                                </div>
                            </div>

                            <div className="tickets" >
                                <div className="ticket-items p-0 m-1"  >
                                    <div className="card chat-box card-success mb-0 pb-0" id="mychatbox2" style={{ minHeight: '80vh' }}>
                                        <CloseChatContext.Provider value={{ state, dispatch }}>
                                            <FilterHeader />
                                            <FilterBody />
                                        </CloseChatContext.Provider>
                                    </div>
                                </div>
                                <div className="ticket-content p-0 m-1">
                                    <div className="ticket-description">
                                        <div className="card chat-box card-success  mb-0 pb-0" id="mychatbox2" style={{ minHeight: '80vh' }}>
                                            <CloseChatContext.Provider value={{ state, dispatch }}>
                                                <ChatHeader />
                                                <ChatBody />
                                                <ChatFooter />
                                            </CloseChatContext.Provider>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ComplateMessages
